document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.search-drawer-button').forEach(function (btn) {
    btn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var container = btn.closest('.header__buttons') || btn.parentElement;
        if (!container) return;
        var searchBox = container.querySelector('.header__search');
        if (!searchBox) return;
        var isOpen = searchBox.classList.contains('header__search--visible');
        document.querySelectorAll('.header__search--visible').forEach(function (box) {
          box.classList.remove('header__search--visible');
        });
        if (!isOpen) {
          searchBox.classList.add('header__search--visible');
          var input = searchBox.querySelector('input');
          if (input) {
            setTimeout(function () {
              input.focus();
            }, 0);
          }
        }
      },
      true
    );
  });

  document.addEventListener('click', function (e) {
    document.querySelectorAll('.header__search--visible').forEach(function (box) {
      if (!box.contains(e.target) && !e.target.closest('.search-drawer-button')) {
        box.classList.remove('header__search--visible');
      }
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.header__search--visible').forEach(function (box) {
        box.classList.remove('header__search--visible');
      });
    }
  });
});
